import React from 'react';

import { CmErrorText } from '@/components/uiParts';
import {
  CustomGroup,
  MAX_GROUP_NAME_LENGTH,
} from '@/pages/link-items/LinkItemsPage';
interface Props {
  validate: CustomGroup['validate'];
}
export const GroupNameErrorMessage: React.FC<Props> = ({ validate }) => {
  return (
    <>
      {validate !== undefined && (
        <>
          {validate.groupName.isMax && (
            <CmErrorText mt="1">
              入力は{MAX_GROUP_NAME_LENGTH}
              文字以内にしてください。
            </CmErrorText>
          )}
          {validate.groupName.isInputed && validate.groupName.isBlank && (
            <CmErrorText mt="1">入力をしてください。</CmErrorText>
          )}
        </>
      )}
    </>
  );
};
